export const FileIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='mask0_149_1722'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='3'
      y='1'
      width='14'
      height='18'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.75 3.125C4.99061 3.125 4.375 3.74061 4.375 4.5V15.5C4.375 16.2594 4.99061 16.875 5.75 16.875H14.25C15.0094 16.875 15.625 16.2594 15.625 15.5V8.125H13.4583C12.0086 8.125 10.8333 6.94975 10.8333 5.5V3.125H5.75ZM15.213 6.69145C15.2709 6.74832 15.3233 6.80978 15.3698 6.875H13.4583C12.6989 6.875 12.0833 6.25939 12.0833 5.5V3.62087L15.213 6.69145ZM3.125 4.5C3.125 3.05025 4.30025 1.875 5.75 1.875H11.016C11.7036 1.875 12.3637 2.14474 12.8544 2.62625L16.0884 5.79919C16.5915 6.29283 16.875 6.96808 16.875 7.67294V15.5C16.875 16.9497 15.6997 18.125 14.25 18.125H5.75C4.30025 18.125 3.125 16.9497 3.125 15.5V4.5ZM12.491 12.9424L10.4456 14.9878C10.2015 15.2319 9.80576 15.2319 9.56168 14.9878L7.51623 12.9424C7.27215 12.6983 7.27215 12.3026 7.51623 12.0585C7.76031 11.8144 8.15603 11.8144 8.40011 12.0585L9.37862 13.037V9.5459C9.37862 9.20072 9.65845 8.9209 10.0036 8.9209C10.3488 8.9209 10.6286 9.20072 10.6286 9.5459V13.037L11.6071 12.0585C11.8512 11.8144 12.2469 11.8144 12.491 12.0585C12.7351 12.3026 12.7351 12.6983 12.491 12.9424Z'
        fill='black'
      />
    </mask>
    <g mask='url(#mask0_149_1722)'>
      <path d='M20 0H0V20H20V0Z' fill='#3BAAB0' />
    </g>
  </svg>
)
